var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrbitShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 320,
    viewBox: "0 0 262 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_181_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M19.2607 594.607L103.409 -51.7885H131.458L104.167 594.607H19.2607Z",
    fill: "url(#paint0_linear_181_2)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M275.793 375.237L187.854 -57.0443L183.009 -55.986L261.126 378.44L275.793 375.237Z",
    fill: "url(#paint1_linear_181_2)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M-34.4518 402.742L66.3033 -56.557L71.1373 -55.428L-19.8193 406.159L-34.4518 402.742Z",
    fill: "url(#paint2_linear_181_2)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M243.111 444.055L176.559 -51.7933H160.647L194.945 444.055H243.111Z",
    fill: "url(#paint3_linear_181_2)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_181_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -52,
    width: 255,
    height: 469
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.444336 416.531H254.978L180.016 -51.7878H83.219L0.444336 416.531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_181_2)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.738,
    height: 538.035,
    transform: "matrix(1 0 0 -1 -1.5058 440.15)",
    fill: "url(#pattern0_181_2)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_181_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_181_2",
    transform: "scale(0.0135135 0.00847458)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_2",
    x1: 61.7139,
    y1: -112.313,
    x2: 61.7139,
    y2: 621.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_2",
    x1: 189.888,
    y1: -90.947,
    x2: 274.442,
    y2: 296.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_2",
    x1: -2.19821,
    y1: 300.482,
    x2: 87.8449,
    y2: -85.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11EADF",
    stopOpacity: 0.72
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_2",
    x1: 200.212,
    y1: -99.4295,
    x2: 200.212,
    y2: 478.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCF4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261.333,
    height: 318.889,
    fill: "white",
    transform: "translate(0.444336 0.472656)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_181_2",
    width: 74,
    height: 118,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAB2CAYAAABvaAWnAAAAAXNSR0IArs4c6QAABMZJREFUeF7tndt2qzAMROH//7l0ESABYlujG5IJfTyVpdHW2JCU5IzT9DcNiX5mMWNCPWMb1CxZw1G7Pg8xAlRbaLbpt9V+hibRrQKVZ97+SsJASabqj2OtUBAXAgqCBAVdhm4IAbVc1zQXCQ0gWW0fUMncoMG6rfUBVVMGAARCKtllTkEhXgsKVZUw7l6gVjuWXCl36jK1e4FydGJeUFoLaKBddR+F9ojGxd5OWGw9vFPNfN9rLy530Jx36y1HaPnGNIDY+Df9TfT7P773KCZ2KyQx4zkhVz2zaqdOvPJS1KdhmJ1Bm+OYCHQUVf3ev3/NlPdWsO7Nr+5w7lzPBNVdq2aCaVBRZ4lZizaJaFDqOkmumMqBf4NSJlRz9Uhg0BPkqO29SO4l1aPnqJzjNE3znUVU/W7qQo5qdcNy9TmYtXh9NaO0Nbfk1jsIKsmB/HVzPw7jRbsBBOWzQ1jTZQXb62WAyuUqM25gogUUGIzNSQbUVAImlBWFOarZxQImVaN7MUbCqo4yys+amm2wzNk1DZijbDtoZss6IDEotCE0bk+PXlNyi62DztMUg7rQZKxSNGRWunewDJRGjWatrEeTVTJQJqUdkqxD8JjFvUA5sGe+1nNU0Enqx1HgoO4PCjmwgBgIFJAHnEu/YRCoftsrKZfdmB5AdekcI9FUmps5SuYWZMfcDBTSsizmAQVycwTltw3A3k5hOj0kKOqQk4leVnnm1ugqXit5j/1Yl+8nH+moyFZQx6Fx7F52icNBuTXJ2tr0+YWB8uyGPebdgpIuJ60YKLgZejJwqmSBxqAa3Qmfxm3ycnJP6qseq2dWsI01r3NU22zs575t2sezpACFy2VGcpxXjP2cuWagIE1QEBPGReGNp1nGYZifWoSfcIu54h3Zb2Lnf9X8fPdi5iiNrIi1sLnXwAqoGHdEACvXTO+oDAMqa/jZrcd1bxpQ8JnB7bAQL6m1girbbZ9QktygpzQp0jgKPVSjyO1AZThIozDU6247Kbmj8oDrE5TBgclN0SeoAKM9n1J/Q2+f0U6OahXd/45xAWHtFUbepjt3b7Ng36QR4PVkJZ0cZdMly0Q2JatZmqA2oZkEO/Pgg6LhWJ0DUa3z6qbeerxWfKN/DtRnp/B2xM+BqvmOOmoaf1zwtXJv2R9HgRMjQVGWBOvUv68OTyCM5J1FtSIkKKG6my0bud9IFt2/8HWigex7O8ru3EjqKMMGSTOBtdqOApOQYtIF8A/4e289wwHFgOrQqTJQrUZrvyMe1DIc/ivVuVx7NvRWPH51W4eTtgZ8+Q0nzpye5lUwWnVkW0+iHCcnyV5cY1lSBcpEiEkSM7anRDf+K4wXd5WjuvrAndJ0OlDK4pzlXk5BNRiCOl29GJ0xQtG+TONe+p5PgGJMQ0Fld9IeYSioRQj9/Cg2c98od1Aq16yLVTkU/PZ13UEpdH4tPQCr0uO9JEKHkA4UKrw5AJMkxwrpQFk60BLm74KCJuLwwUaorksQ70ySSgh3lMNxImXRXHcA1YtoFxJEUh9HlYinmQK+Vbu9j4pw0lbTx1GRHbG+vAYX+vwHOntWjeMhyFGVc+Kycww9pwT3UZf1gO+GQiQKoFakvt7YUVqhlQaUf2W2GPI/zra2RT8Uq3AAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbitShine);
export default __webpack_public_path__ + "static/media/orbit-shine.93053bfd17aab1a452032314fea29cd6.svg";
export { ForwardRef as ReactComponent };